/** Chat Save / Unsave / Dismiss and a Compendium delete tell the panel to reload. */
export const SAVED_IDEAS_CHANGED = 'brainstormy:saved-ideas-changed';

export function notifySavedIdeasChanged(detail = {}) {
  window.dispatchEvent(new CustomEvent(SAVED_IDEAS_CHANGED, { detail }));
}
